import * as React from 'react';
import Box from '@mui/joy/Box';
import { Grid, Stack } from '@mui/joy';
import Button from '@mui/joy/Button';
import Card from '@mui/joy/Card';
import CardActions from '@mui/joy/CardActions';
import Chip from '@mui/joy/Chip';
import Divider from '@mui/joy/Divider';
import List from '@mui/joy/List';
import ListItem from '@mui/joy/ListItem';
import ListItemDecorator from '@mui/joy/ListItemDecorator';
import Typography from '@mui/joy/Typography';
import Check from '@mui/icons-material/Check';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import AddIcon from '@mui/icons-material/Add';

const amount = ['2,225.61', '2,225.61', '2,225.61', '2,225.61', '2,225.61',]

export const FundiProfileDashboard = () => {
    return (
        <>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                {
                    amount.map((data, index) => {
                        return (
                            <Grid item xs={6} key={index}>
                                <Box
                                    sx={{
                                        border: "1px solid #28A745",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        height: '172px',
                                        width: '294px',
                                        margin: "auto", // Center the box within the page
                                        textAlign: "center",
                                        borderRadius: "1px",
                                    }}
                                >
                                    <img width={45} height={45} src="assets/images/icons/Asset 1.png" alt="" />
                                    <Typography variant="h5">
                                        £ {data}
                                    </Typography>
                                    <Typography variant="h6" >
                                        Total Spend
                                    </Typography>
                                    <Typography variant="body">
                                        Refresh
                                    </Typography>

                                </Box>
                            </Grid>
                        )
                    })
                }


            </Grid>

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",  // Centers the boxes horizontally
                    alignItems: "center",       // Centers vertically (if needed)
                    gap: 2,                     // Space between boxes
                    flexWrap: "wrap",            // Allows wrapping on smaller screens
                    marginTop: 4,
                }}
            >
                {[1, 2, 3].map((item, index) => (
                    <Box
                        key={index}
                        sx={{
                            width: "225px",
                            height: "96px",
                            border: "1px solid #28A745",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            textAlign: "center",
                            borderRadius: "1px",
                        }}
                    >
                        <Typography variant="h6">Total Bid{item}</Typography>
                        <Typography variant="body1">Refresh</Typography>
                    </Box>
                ))}
            </Box>

        </>
    )
}


export const FundiProfileWallet = () => {
    return (
        <>
            <Box
                sx={{
                    width: '94%',
                    height: '100%',
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "end",
                    mb: "16px",

                }}
            >
                <Button
                    sx={{
                        backgroundColor: '#28A745',
                        color: '#fff',
                        width: '220px',
                        height: '39px',
                        borderRadius: '6px',
                        fontSize: '18px',
                        fontWeight: 500,
                        textAlign: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 1,
                        "&:hover": {
                            backgroundColor: "#218838",
                        }
                    }}
                >
                    <AddIcon sx={{ fontSize: 28, color: "#fff" }} />
                    <Typography sx={{ fontSize: '16px', color: '#fff', fontWeight: 400 }}>
                        Withdrow Amount
                    </Typography>
                </Button>
            </Box>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>

                {
                    amount.map((data, index) => {
                        return (
                            <Grid item xs={6} key={index}>
                                <Box
                                    sx={{
                                        border: "1px solid #28A745",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        height: '172px',
                                        width: '294px',
                                        margin: "auto", // Center the box within the page
                                        textAlign: "center",
                                        borderRadius: "1px",
                                    }}
                                >
                                    <img width={45} height={45} src="assets/images/icons/Asset 1.png" alt="" />
                                    <Typography variant="h5">
                                        £ {data}
                                    </Typography>
                                    <Typography variant="h6" >
                                        Total Spend
                                    </Typography>
                                    <Typography variant="body">
                                        Refresh
                                    </Typography>

                                </Box>
                            </Grid>
                        )
                    })
                }


            </Grid>



        </>
    )
}


export const FundiProfileSubscription = () => {
    return (
        <>
            <Box
                sx={{
                    width: '94%',
                    height: '100%',
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "end",
                    mb: "16px",

                }}
            >
                <Button
                    sx={{
                        backgroundColor: '#28A745',
                        color: '#fff',
                        width: '220px',
                        height: '39px',
                        borderRadius: '6px',
                        fontSize: '18px',
                        fontWeight: 500,
                        textAlign: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 1,
                        "&:hover": {
                            backgroundColor: "#218838",
                        }
                    }}
                >

                    <Typography sx={{ fontSize: '16px', color: '#fff', fontWeight: 400 }}>
                        Update Plan
                    </Typography>
                </Button>
            </Box>



            <Card
                size="lg"
                variant="solid"
                color="red"

                sx={{backgroundColor:'#F4F4F4', borderRadius: "10px", border:'none' }}
            >
                <Stack
                    direction="row"
                    sx={{ justifyContent: 'space-between', alignItems: 'center' }}
                >
                    <Typography  level="h3" sx={{color:'#666666'}}>
                        Extended Plan
                    </Typography>
                    <Box>
                        <Typography level="h2" sx={{color:'#28A745'}}>
                        € 99.92
                        </Typography>
                        <Typography gutterBottom variant="body-sm" component="div">
                        Incl all taxes
                        </Typography>
                    </Box>
                </Stack>
               
               <Box sx={{padding:'5px'}}>
               <Stack
                    direction="row"
                    sx={{ justifyContent: 'space-between', alignItems: 'center',padding: '5px 15px 5px' }}
                >
                    <Typography gutterBottom variant="h5" component="div">
                        Package Duration
                    </Typography>
                    <Typography gutterBottom variant="h6" component="div">
                        1 Months
                    </Typography>
                </Stack>
                <Divider inset="none" sx={{ height: '2px', backgroundColor: '#03fc0b' }} />
                <Stack
                    direction="row"
                    sx={{ justifyContent: 'space-between', alignItems: 'center',padding: '5px 15px 5px'}}
                >
                    <Typography gutterBottom variant="h5" component="div">
                        Package Duration
                    </Typography>
                    <Typography gutterBottom variant="h6" component="div">
                        1 Months
                    </Typography>
                </Stack>
                <Divider inset="none" sx={{ height: '2px', backgroundColor: '#03fc0b' }} />
                <Stack
                    direction="row"
                    sx={{ justifyContent: 'space-between', alignItems: 'center',padding: '5px 15px 5px'}}
                >
                    <Typography gutterBottom variant="h5" component="div">
                        Package Duration
                    </Typography>
                    <Typography gutterBottom variant="h6" component="div">
                        1 Months
                    </Typography>
                </Stack>
                <Divider inset="none" sx={{ height: '2px', backgroundColor: '#03fc0b' }} />
                <Stack
                    direction="row"
                    sx={{ justifyContent: 'space-between', alignItems: 'left',padding: '5px 15px 5px'}}
                >
                    <Typography gutterBottom variant="h5" component="div">
                        Package Duration
                    </Typography>
                    <ListItemDecorator sx={{width:'70px',display:'flex',justifyContent:'center'}}>
                        <Check />
                    </ListItemDecorator>
                </Stack>
                <Divider inset="none" sx={{ height: '2px', backgroundColor: '#03fc0b' }} />
                <Stack
                    direction="row"
                    sx={{ justifyContent: 'space-between', alignItems: 'center' ,padding: '5px 15px 5px'}}
                >
                    <Typography gutterBottom variant="h5" component="div">
                        Package Duration
                    </Typography>
                    <Typography gutterBottom variant="h6" component="div">
                        1 Months
                    </Typography>
                </Stack>
               </Box>

            </Card>



        </>
    )
}
